/* 회사 위치로 지도를 되돌리는 버튼.
 *
 * 지도를 끌고 다니다 보면 기준점을 잃는다. 이 앱의 거리 표시는 전부 "회사에서 몇 m"
 * 라서(VITE_ORIGIN), 회사가 화면 밖으로 나가면 그 숫자를 눈으로 대조할 데가 없다.
 *
 * 확대 배율은 건드리지 않는다. 눌렀을 때 보던 범위까지 바뀌면 "어디를 보고 있었지"가
 * 되고, 사용자가 요청한 건 중심을 옮기는 것뿐이다.
 *
 * 아이콘은 건물이다. '내 위치'가 생기면서 십자선을 그쪽에 넘겼다 — 십자선 둘이 한
 * 지도 위에 있으면 어느 쪽이 회사고 어느 쪽이 나인지 눌러보기 전에는 모른다. 지금은
 * 둘이 서로 다른 모서리에 있지만(위/아래) 그래도 그림이 갈라져 있는 편이 낫다.
 *
 * 좁은 화면에서는 이 버튼을 접는다 — 어디서 접는지는 App.jsx 의 MapChrome 안에 있다.
 */

import { Building2 } from "lucide-react";

import { Button } from "@/components/ui/button";

import { cn } from "../lib/util.js";
import { FLOAT_BTN } from "./Overlays.jsx";

export function RecenterButton({ map, origin, className }) {
  /* origin 이 없으면 아예 그리지 않는다. VITE_ORIGIN 이 비고 브라우저 위치도 막히면
     돌아갈 곳 자체가 없는데, 그때 버튼만 남으면 눌러도 아무 일이 안 일어난다. */
  if (!map || !origin) return null;

  return (
    <Button
      aria-label="회사 위치로"
      className={cn(FLOAT_BTN, "size-10 rounded-full", className)}
      id="btn-recenter"
      onClick={() => map.panTo(new window.kakao.maps.LatLng(origin[0], origin[1]))}
      size="icon-lg"
      title="회사 위치로"
      variant="ghost"
    >
      <Building2 className="size-[18px]" />
    </Button>
  );
}
